module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "support-widget widget"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [(_vm.unread && _vm.unread.count > 0) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.unread.count))]) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("Support Tickets"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Your recent support tickets.'),
      expression: "'Your recent support tickets.'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "toggle-widget",
    on: {
      "click": function($event) {
        _vm.open = !_vm.open
      }
    }
  }, [(_vm.open === true) ? _c('i', {
    staticClass: "fa fa-minus"
  }) : _c('i', {
    staticClass: "fa fa-plus"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }],
    staticClass: "panel-body"
  }, [(_vm.unread) ? _vm._m(0) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('VuePerfectScrollbar', {
    staticClass: "scroll-area"
  }, [(_vm.unread.count > 0) ? _c('ul', {
    staticClass: "unread"
  }, _vm._l((_vm.unread.rows), function(message) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'support',
          query: {
            ticket: message.ticketId
          }
        }
      }
    }, [_c('p', [_vm._v(_vm._s(_vm._f("truncate")(_vm._f("stripTags")(message.body), 100)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("shortDate")(message.createdAt)))])])], 1)
  })) : _c('p', {
    staticClass: "text-center"
  }, [_vm._v("No new replies to your tickets")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e2d19e96!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/Support.vue
// module id = 2113
// module chunks = 2